export default {
    dataTagsNews: [],
}
